(function() {
  var BaseDialog,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseDialog = App.loadClass("core::reports/BaseDialog");

  exports.Audit_Dialog = (function(superClass) {
    extend(Audit_Dialog, superClass);

    function Audit_Dialog() {
      return Audit_Dialog.__super__.constructor.apply(this, arguments);
    }

    Audit_Dialog.prototype.init = function() {
      Audit_Dialog.__super__.init.call(this);
      this.layoutUrl = 'backend/portal/audit/dialog';
      this.subHandlers = {
        'Audit_Report': {
          'class': 'portal::handlers/audit/Audit_SubHandler'
        }
      };
      this.defaultSub = 'Audit_Report';
      return this.createDialog();
    };

    Audit_Dialog.prototype.afterLoadLayout = function(selector, data) {
      var ths;
      this.openDialog();
      ths = this;
      this.msg = this.dialog.find('.message_writer');
      this.audit_subHandler = this.createSubHandler(this.defaultSub);
      if (this.audit_subHandler) {
        this.audit_subHandler.init(data);
      }
      $(this.parent.layoutSelector).find('.apply-filters').bind('click', (function(_this) {
        return function() {
          return _this.audit_subHandler.refreshReport();
        };
      })(this));
      this.dialog.delegate('.excel-btn', 'click', (function(_this) {
        return function() {
          var url;
          ths = _this;
          url = ths.audit_subHandler.excelUrl + "?" + $.param({
            query: ko.toJSON(_this.filters.jsonize())
          });
          return window.open(url, '_blank');
        };
      })(this));
      return $(window).unbind('finished_report_load modal_resized').bind('finished_report_load modal_resized', debounce((function(_this) {
        return function(e) {
          return ths.resize();
        };
      })(this)));
    };

    Audit_Dialog.prototype.resize = function() {
      var element;
      element = this.dialog.find('.audit-container');
      element.resizr();
      return this.audit_subHandler.currentOutput.resizeTable();
    };

    return Audit_Dialog;

  })(BaseDialog);

}).call(this);
